import axiosInstance from '@/utils/api.js'

function validation (payload) {
  payload.is_enabled = parseInt(payload.is_enabled, 10)
  payload.group_id = parseInt(payload.group_id, 10)
}

var state = {
  avail_reports_settings: []
}

var getters = {
  AVAIL_REPORTS_SETTINGS: (state) => {
    return state.avail_reports_settings
  }
}

var mutations = {
  SET_AVAIL_REPORTS_SETTINGS: (state, payload) => {
    state.avail_reports_settings = payload
  }
}

var actions = {
  GET_AVAIL_REPORTS_SETTINGS: async (context, payload) => {
    let result = await axiosInstance.get('/settings/available_reports')
    if (result.status === 200) {
      context.commit('SET_AVAIL_REPORTS_SETTINGS', result.data)
    }
  },
  UPDATE_AVAIL_REPORTS_SETTINGS: (context, payload) => {
    validation(payload)
    return axiosInstance.put('/settings/available_reports', payload)
  },
  DELETE_AVAIL_REPORTS_SETTINGS: (context, payload) => {
    return axiosInstance.delete('/settings/available_reports?id=' + payload)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/settings/reports_settings.js